import { render, staticRenderFns } from "./JournalAgreement.vue?vue&type=template&id=7d987a42"
import script from "./JournalAgreement.vue?vue&type=script&lang=js"
export * from "./JournalAgreement.vue?vue&type=script&lang=js"
import style0 from "./JournalAgreement.vue?vue&type=style&index=0&id=7d987a42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports